// src/Dashboard/pages/user/PassageCeintureDocuments/components/PassageCeintureDocumentsToolbar.jsx

import React from "react";
import { FaFilter, FaPlus, FaSearch, FaTimes } from "react-icons/fa";

export default function PassageCeintureDocumentsToolbar({
  ui,
  updateUi,
  debouncedSearch,
  setDebouncedSearch,
  belts = [],
  canManage,
  onReset,
  onCreate,
}) {
  const fieldClass =
    "w-full rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-white";

  return (
    <div className="rounded-[24px] border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-900/60">
      <div className="mb-4 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <div className="inline-flex items-center gap-2 text-sm font-bold text-slate-900 dark:text-white">
            <FaFilter />
            Filtres documents
          </div>

          <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
            Recherchez un document ou filtrez par ceinture.
          </p>
        </div>

        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            onClick={onReset}
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-white px-3 py-2 text-xs font-bold text-slate-700 ring-1 ring-slate-200 transition hover:bg-slate-50 dark:bg-slate-950 dark:text-slate-200 dark:ring-slate-700 dark:hover:bg-slate-900"
          >
            <FaTimes />
            Réinitialiser
          </button>

          {canManage && (
            <button
              type="button"
              onClick={onCreate}
              className="inline-flex items-center justify-center gap-2 rounded-2xl bg-[#013E8E] px-3 py-2 text-xs font-bold text-white transition hover:bg-indigo-800"
            >
              <FaPlus />
              Ajouter
            </button>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 gap-3 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Recherche
          </label>

          <div className="relative">
            <FaSearch className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />

            <input
              type="text"
              value={debouncedSearch}
              onChange={(event) => setDebouncedSearch(event.target.value)}
              placeholder="Titre, description, ceinture..."
              className="w-full rounded-2xl border border-slate-200 bg-white py-2 pl-9 pr-3 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
            />
          </div>
        </div>

        <div>
          <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Ceinture
          </label>

          <select
            value={ui.belt}
            onChange={(event) =>
              updateUi({
                belt: event.target.value,
                perPage: 24,
              })
            }
            className={fieldClass}
          >
            <option value="all">Toutes les ceintures</option>

            {belts.map((belt) => (
              <option key={belt} value={belt}>
                {belt}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Tri
          </label>

          <select
            value={ui.sort}
            onChange={(event) =>
              updateUi({
                sort: event.target.value,
                perPage: 24,
              })
            }
            className={fieldClass}
          >
            <option value="beltOrderTitle">Ceinture ▸ Ordre ▸ Titre</option>
            <option value="belt">Ceinture ▸ Titre</option>
            <option value="alpha">Titre A-Z</option>
          </select>
        </div>
      </div>

      {canManage && (
        <div className="mt-4">
          <label className="inline-flex cursor-pointer items-center gap-3 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-bold text-slate-700 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200">
            <input
              type="checkbox"
              checked={!!ui.showDrafts}
              onChange={(event) =>
                updateUi({
                  showDrafts: event.target.checked,
                  perPage: 24,
                })
              }
            />
            Afficher aussi les brouillons
          </label>
        </div>
      )}
    </div>
  );
}